class VariantScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListeners();
  }

  addEventListeners() {
    this.querySelectorAll(".variant-item").forEach((item) => {
      item.addEventListener("click", (event) =>
        this.handleVariantClick(event, item)
      );
    });

    this.querySelector(".atc-button").addEventListener("click", () =>
      this.handleAddToCart()
    );
  }

  handleVariantClick(event, item) {
    if (item.dataset.variantAvailable === "false") return;

    this.querySelectorAll(".variant-item").forEach((el) => {
      el.classList.remove("selected");
      el.classList.toggle("hidden");
    });
    
    item.classList.add("selected");
    item.classList.toggle("hidden");
    item.parentElement.classList.toggle("height");
    item.querySelector(".arrow")?.classList.toggle("hidden");
    item.querySelector(".low-stock-message")?.classList.toggle("hidden");
    this.querySelector("#select_text").style.opacity = "0";

    const atcButton = this.querySelector(".atc-button");
    atcButton.removeAttribute("disabled");
    atcButton.dataset.variantId = item.dataset.variantId;
  }

  handleAddToCart() {
    const atcButton = this.querySelector(".atc-button");
    const variantId = atcButton.dataset.variantId;

    if (!variantId) {
      this.querySelector("#select_text").style.opacity = "1";
      return;
    }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((response) => response.json())
      .then((data) => {
        document.dispatchEvent(
          new CustomEvent("ajaxProduct:added", { detail: data })
        );
      })
      .catch((error) => console.error("Error adding to cart:", error));
  }
}

customElements.define("variant-scroll", VariantScroll);
